import { render } from "./PostCodes.vue?vue&type=template&id=7370b817&scoped=true"
import script from "./PostCodes.vue?vue&type=script&lang=js"
export * from "./PostCodes.vue?vue&type=script&lang=js"

import "./PostCodes.vue?vue&type=style&index=0&id=7370b817&scoped=true&lang=css"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7370b817"]])

export default __exports__